<template>
  <Form
    class="flex flex-col gap-6 w-full"
    :resolver="givesDayResolver"
    :initialValues="initialValues"
    ref="givesDayForm"
    v-slot="$form"
    v-focustrap
    data-test="gives-day-form"
  >
    <LabeledField
      label="Company Goal"
      :field="$form.companyGoal"
    >
      <InputNumber
        data-test="company-goal"
        name="companyGoal"
        mode="currency"
        currency="USD"
        locale="en-US"
        fluid
      />
    </LabeledField>
    <LabeledField
      label="Featured Causes Text"
      :field="$form.featuredCausesText"
    >
      <Textarea
        name="featuredCausesText"
        fluid
        data-test="featured-causes-text"
      />
      <div
        class="text-sm text-gray-500"
        data-test="featured-char-count"
      >
        <i class="fas fa-info-circle"></i>
        {{ ($form.featuredCausesText?.value || '').length }}/560 Characters
      </div>
    </LabeledField>
    <LabeledField
      label="Participation Text"
      :field="$form.participationText"
    >
      <Textarea
        data-test="participation-text"
        name="participationText"
        autoResize
        fluid
      />
      <div
        class="text-sm text-gray-500 mt-1"
        data-test="participation-char-count"
      >
        <i class="fas fa-info-circle"></i>
        {{ ($form.participationText?.value || '').length }}/560 Characters
      </div>
    </LabeledField>
  </Form>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import { z } from 'zod';
import { zodResolver } from '@primevue/forms/resolvers/zod';
import { useCompanyAdminStore } from '@/stores/CompanyAdminStore.js';
import LabeledField from '@/components/forms/LabeledField.vue';

const givesDayForm = ref(null);
const givesDayResolver = zodResolver(
  z.object({
    companyGoal: z.number().nonnegative('Goal cannot be negative').max(1000000, 'Goal exceeds maximum allowed amount'),
    featuredCausesText: z.string().max(560, 'Maximum 560 characters allowed'),
    participationText: z.string().max(560, 'Maximum 560 characters allowed'),
  }),
);

const companyAdminStore = useCompanyAdminStore();

const initialValues = computed(() => ({
  companyGoal: companyAdminStore.company.companyGoal ?? 0,
  featuredCausesText: companyAdminStore.company.featuredCausesText,
  participationText: companyAdminStore.company.participationText,
}));

onMounted(() => {
  companyAdminStore.givesDayForm = givesDayForm.value;
});
</script>
